export const isPlatoEnEvento = (p) =>
    !!(
        p?.participacionEvento ||
        (Array.isArray(p?.eventos) && p.eventos.length > 0) ||
        (Array.isArray(p?.participaciones) && p.participaciones.length > 0) ||
        (p?.eventosCount || 0) > 0 ||
        !!p?.asignadoAEvento
    );
